module.exports = __webpack_public_path__ + "img/more-icon.bff9cbf4.svg";